var e="@hpstellar/core/tile";export{e as tileTestId};
